import { z } from 'zod';
/**
 * Требование оплаты (доп. счёт) по перевозке.
 *
 * Доп. расходы, возникшие в процессе перевозки и не вошедшие в согласованную
 * котировку. Менеджер фиксирует их позициями (у каждой — своя ставка НДС) и
 * выставляет клиенту; клиент видит сумму к доплате. Оплата отмечается
 * вручную/из 1С.
 */
export const paymentDemandStatusSchema = z.enum(['DRAFT', 'ISSUED', 'PAID', 'CANCELLED']);
/** Позиция требования (доп. расход): цена без НДС и своя ставка НДС. */
export const paymentDemandLineSchema = z.object({
    name: z.string().min(1).max(300),
    amountNet: z.number().nonnegative(),
    vatRate: z.number().min(-1).max(100),
});
/** Создание требования оплаты менеджером. */
export const paymentDemandCreateSchema = z.object({
    currency: z
        .string()
        .length(3)
        .regex(/^[A-Z]{3}$/, 'currency должен быть 3-х буквенным ISO 4217 кодом'),
    lines: z.array(paymentDemandLineSchema).min(1),
    comment: z.string().max(2000).optional(),
    /** Сразу выставить клиенту (ISSUED), а не оставлять черновиком. */
    issueNow: z.boolean().optional(),
});
/** DTO требования оплаты. */
export const paymentDemandDtoSchema = z.object({
    id: z.string(),
    shipmentId: z.string(),
    number: z.string(),
    status: paymentDemandStatusSchema,
    currency: z.string(),
    amountNet: z.number(),
    vatAmount: z.number(),
    amount: z.number(),
    lines: z.array(paymentDemandLineSchema),
    comment: z.string().nullable(),
    issuedAt: z.string().datetime().nullable(),
    paidAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=payment-demands.js.map